import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from 'store/actions/reports';
import { ReportsResponse, NewReportResponse, AgenciesResponse } from 'store/types/reports';

const initialState: Array<ReportsResponse> = [];
const initialStateNew: Array<NewReportResponse> = [];
const initialStateAgencies: Array<AgenciesResponse> = [];

export const ReportsReducer = createReducer<Array<ReportsResponse>, ActionType<typeof actions>>(
  initialState,
).handleAction(actions.getReports.success, (state, { payload }) => ({
  ...state,
  ...payload,
}));

export const NewReportsReducer = createReducer<Array<NewReportResponse>, ActionType<typeof actions>>(
  initialStateNew,
).handleAction(actions.getNewReports.success, (state, { payload }) => ({
  ...state,
  ...payload,
}));

export const AllAgenciesReducer = createReducer<Array<AgenciesResponse>, ActionType<typeof actions>>(
  initialStateAgencies,
).handleAction(actions.getAllAgencies.success, (state, { payload }) => ({
  ...state,
  ...payload,
}));
